<template>
    <div class="app-container">
        <!-- 头部导航 -->

        <!-- 头部导航 -->
        <header class="header">
            <div class="header-left">
                <img src="../assets/images/logo.png" alt="Logo" class="logo" />
            </div>

            <!-- 使用Vue控制菜单状态 -->
            <nav class="header-nav" :class="{ active: isMenuOpen }">
                <a href="#intro" class="nav-link" @click="closeMenu">介绍</a>
                <a href="#login" class="nav-link" @click="closeMenu">去登录</a>
                <a href="#download" class="nav-link" @click="closeMenu"
                    >APP下载</a
                >
            </nav>

            <!-- 汉堡菜单按钮 -->
            <button
                class="hamburger"
                :class="{ active: isMenuOpen }"
                @click="toggleMenu"
                aria-label="菜单"
            >
                <span class="hamburger-line"></span>
                <span class="hamburger-line"></span>
                <span class="hamburger-line"></span>
            </button>
        </header>

        <!-- 主要内容 -->
        <main class="main-content">
            <!-- 介绍部分 -->
            <!-- <section id="intro" class="section intro-section">
                <h2 class="section-title">APP介绍</h2>
                <div class="section-content">
                    <p>
                        阿斯达几乎发狂建设步伐加快哈市办公交卡还不赶紧暗红色的封闭空间拉萨的过吧就好爱好放假啊开始的噶于是就很贵的吧奥数风格吧U影开始就很反感
                    </p>
                    <p>
                        更多精彩功能等待您的发现，我们的APP致力于为您提供最优质的服务体验，让生活更便捷。
                    </p>
                </div>
                <div class="features-grid">
                    <div class="feature-card">
                        <div class="feature-icon">📱</div>
                        <h3>便捷操作</h3>
                        <p>简洁直观的界面设计，操作简单易上手</p>
                    </div>
                    <div class="feature-card">
                        <div class="feature-icon">⚡</div>
                        <h3>极速响应</h3>
                        <p>优化算法保证流畅使用体验</p>
                    </div>
                    <div class="feature-card">
                        <div class="feature-icon">🔒</div>
                        <h3>安全可靠</h3>
                        <p>多重加密保护您的数据安全</p>
                    </div>
                </div>
            </section> -->
            <section id="intro" class="section intro-section">
                <h2 class="section-title">APP介绍</h2>
                <div class="section-content">
                    <p>
                        该APP系统具备全面且实用的功能，旨在为用户提供便捷的设备管理与文件传输体验。
                        在用户管理方面，支持用户注册登录以及用户信息修改功能，用户可轻松管理个人账户，修改头像、用户名和密码等关键信息，保障账户安全与个性化设置。
                        文件传输功能十分高效，用户可以上传大文件，上传成功后系统会生成下载链接和提取码，并可设置下载有效期以及提供下载的六位或九位口令，支持断点续传，确保大文件传输的稳定性和可靠性。通过下载链接，输入提取码即可下载文件，同样支持断点续传；也可以通过输入口令直接下载文件，满足不同场景下的下载需求。
                        此外，系统还具备分享下载链接的功能。
                        这一系列功能相互配合，为用户打造了一个功能完备、操作便捷的设备管理与文件传输平台。
                    </p>
                </div>

                <!-- 图片展示区 -->
                <div class="app-screenshots">
                    <div class="screenshot-item">
                        <img
                            src="../assets/images/one.jpg"
                            alt="APP界面截图1"
                            class="screenshot-img"
                        />
                        <p class="screenshot-caption">高效的功能操作</p>
                    </div>
                    <div class="screenshot-item">
                        <img
                            src="../assets/images/two.jpg"
                            alt="APP界面截图2"
                            class="screenshot-img"
                        />
                        <p class="screenshot-caption">简洁直观的主界面</p>
                    </div>
                </div>

                <!-- 特色功能 -->
                <div class="features-grid">
                    <div class="feature-card">
                        <div class="feature-icon">📱</div>
                        <h3>便捷操作</h3>
                        <p>简洁直观的界面设计，操作简单易上手</p>
                    </div>
                    <div class="feature-card">
                        <div class="feature-icon">⚡</div>
                        <h3>极速响应</h3>
                        <p>优化算法保证流畅使用体验</p>
                    </div>
                    <div class="feature-card">
                        <div class="feature-icon">🔒</div>
                        <h3>安全可靠</h3>
                        <p>多重加密保护您的数据安全</p>
                    </div>
                </div>
            </section>

            <!-- 登录部分 -->
            <section id="login" class="section login-section">
                <h2 class="section-title">去登录</h2>
                <div class="login-box">
                    <p>立即登录体验完整功能</p>
                    <button class="action-btn" @click="toUrl">立即登录</button>
                </div>
            </section>

            <!-- 下载部分 -->
            <section id="download" class="section download-section">
                <h2 class="section-title">下载APP</h2>
                <div class="download-box">
                    <p class="download-description">立即下载体验完整功能</p>

                    <!-- 单个下载按钮 -->
                    <a
                        :href="apkDownloadUrl"
                        class="single-download-btn"
                        target="_blank"
                    >
                        <i class="icon-download"></i> 立即下载
                    </a>
                </div>
            </section>
            <!-- <section id="download" class="section download-section">
                <h2 class="section-title">去下载APP</h2>
                <div class="download-box">
                    <p>扫描下方二维码下载APP</p>
                    <div class="qr-code-placeholder"></div>
                    <div class="download-btns">
                        <button class="download-btn ios-btn">
                            <i class="icon-apple"></i> App Store
                        </button>
                        <button class="download-btn android-btn">
                            <i class="icon-android"></i> Google Play
                        </button>
                    </div>
                </div>
            </section> -->
        </main>

        <!-- 页脚 -->
        <footer class="footer">
            <p>© 2023 我的APP. 版权所有</p>
            <div class="footer-links">
                <a href="#">隐私政策</a>
                <a href="#">用户协议</a>
                <a href="#">联系我们</a>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isMenuOpen: false,
            apkDownloadUrl: 'https://panmiaoda.com/秒达.apk'
        }
    },
    methods: {
        toUrl() {
            // window.open('http://96.9.231.213:8092/#/HelloWorld', '_blank')
            this.$router.push('/login')
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen
        },
        closeMenu() {
            this.isMenuOpen = false
        }
        // toggleMenu() {
        //     this.menuActive = !this.menuActive
        // }
        // toggleMenu() {
        //     const nav = document.querySelector('.header-nav')
        //     nav.classList.toggle('active')
        // }
    }
}
</script>

<style lang="scss" scoped>
/* 基础样式 */
:root {
    --primary-color: #047ef8;
    --secondary-color: #6c757d;
    --light-color: #f8f9fa;
    --dark-color: #343a40;
    --border-radius: 8px;
    --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    --transition: all 0.3s ease;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
    line-height: 1.6;
    color: #333;
}

.app-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

/* 头部样式 */
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background: white;
    position: fixed;
    z-index: 1000;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    top: 0;
    width: 100%;
    .header-left {
        img {
            width: 50px;
        }
    }

    .header-nav {
        display: flex;
        gap: 2rem;

        .nav-link {
            color: #333;
            text-decoration: none;
            font-weight: 500;
            transition: color 0.3s;

            &:hover {
                color: #047ef8;
            }
        }
    }

    .hamburger {
        display: none;
        background: none;
        border: none;
        cursor: pointer;
        padding: 0.5rem;
        flex-direction: column;
        justify-content: space-between;
        width: 2rem;
        height: 1.5rem;
        z-index: 1001;

        .hamburger-line {
            display: block;
            height: 2px;
            width: 100%;
            background: #333;
            transition: all 0.3s ease;
        }

        &.active {
            .hamburger-line:nth-child(1) {
                transform: translateY(0.5rem) rotate(45deg);
            }
            .hamburger-line:nth-child(2) {
                opacity: 0;
            }
            .hamburger-line:nth-child(3) {
                transform: translateY(-0.5rem) rotate(-45deg);
            }
        }
    }
}

/* 主要内容样式 */
.app-screenshots {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin: 40px auto;
    max-width: 1000px;

    .screenshot-item {
        text-align: center;
        flex: 1;
        min-width: 0;
    }

    .screenshot-img {
        width: 100%;
        max-width: 400px;
        height: auto;
        border-radius: 12px;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        cursor: pointer;

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
        }
    }

    .screenshot-caption {
        margin-top: 15px;
        font-size: 1rem;
        color: var(--secondary-color);
    }
}
.main-content {
    flex: 1;
    padding-top: 100px;
}

.section {
    padding: 80px 5%;
    scroll-margin-top: 80px;

    &:nth-child(odd) {
        background-color: var(--light-color);
        // background-color: #047ef8;
    }
}

.section-title {
    text-align: center;
    font-size: 2.2rem;
    margin-bottom: 40px;
    color: var(--dark-color);
    position: relative;
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);

    &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 100%;
        height: 3px;
        background-color: var(--primary-color);
        border-radius: 3px;
    }
}

.section-content {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
    font-size: 1.1rem;
    line-height: 1.8;
    color: var(--secondary-color);
}

/* 特色功能网格 */
.features-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    margin-top: 50px;
}

.feature-card {
    background: white;
    padding: 30px;
    border-radius: var(--border-radius);
    box-shadow: var(--box-shadow);
    text-align: center;
    transition: var(--transition);

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    }

    .feature-icon {
        font-size: 2.5rem;
        margin-bottom: 15px;
    }

    h3 {
        margin-bottom: 10px;
        color: var(--dark-color);
    }

    p {
        color: var(--secondary-color);
        font-size: 0.95rem;
    }
}

/* 登录和下载区域 */
.login-box,
.download-box {
    max-width: 500px;
    margin: 0 auto;
    background: white;
    padding: 40px;
    border-radius: var(--border-radius);
    box-shadow: var(--box-shadow);
    text-align: center;
}

.action-btn {
    background-color: #047ef8;
    color: white;
    border: none;
    padding: 12px 30px;
    font-size: 1rem;
    border-radius: 50px;
    cursor: pointer;
    margin-top: 20px;
    transition: var(--transition);
    font-weight: 500;

    &:hover {
        background-color: darken(#047ef8, 10%);
        transform: translateY(-2px);
    }
}

.qr-code-placeholder {
    width: 150px;
    height: 150px;
    margin: 20px auto;
    background-color: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--border-radius);
}

.download-btns {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 20px;
}

.download-btn {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border-radius: var(--border-radius);
    font-weight: 500;
    cursor: pointer;
    transition: var(--transition);

    i {
        margin-right: 8px;
        font-size: 1.2rem;
    }

    &.ios-btn {
        background-color: #000;
        color: white;
    }

    &.android-btn {
        background-color: #3ddc84;
        color: white;
    }

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
}

/* 页脚样式 */
.footer {
    background-color: var(--dark-color);
    color: white;
    text-align: center;
    padding: 30px 5%;
    margin-top: 50px;

    p {
        margin-bottom: 15px;
    }

    .footer-links {
        display: flex;
        justify-content: center;
        gap: 20px;

        a {
            color: rgba(255, 255, 255, 0.7);
            text-decoration: none;
            transition: var(--transition);

            &:hover {
                color: white;
            }
        }
    }
    /* 下载部分样式 */
    .download-section {
        background-color: #f8f9fa;
    }

    .download-box {
        max-width: 500px;
        margin: 0 auto;
        padding: 30px;
        background: white;
        border-radius: var(--border-radius);
        box-shadow: var(--box-shadow);
        text-align: center;
    }

    .download-description {
        font-size: 1.1rem;
        color: var(--secondary-color);
        margin-bottom: 30px;
    }

    .single-download-btn {
        display: inline-flex;
        align-items: center;
        padding: 14px 32px;
        border-radius: 50px;
        font-weight: 500;
        text-decoration: none;
        transition: var(--transition);
        background-color: var(--primary-color);
        color: white;
        font-size: 1.1rem;
        box-shadow: 0 4px 12px rgba(4, 126, 248, 0.3);

        i {
            margin-right: 8px;
            font-size: 1.2rem;
        }

        &:hover {
            background-color: darken(#047ef8, 10%);
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(4, 126, 248, 0.4);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
    .app-screenshots {
        flex-direction: column;
        align-items: center;
        gap: 30px;

        .screenshot-item {
            width: 100%;
            max-width: 350px;
        }
    }
    .header {
        position: sticky;
        top: 0;
        .header-left {
            img {
                width: 35px;
            }
        }

        .header-nav {
            /* 初始状态隐藏 */
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            background: white;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 2rem;
            transform: translateX(-100%);
            transition: transform 0.3s ease;
            padding-top: 5rem;

            /* 激活状态 */
            &.active {
                transform: translateX(0);
            }

            .nav-link {
                font-size: 1.2rem;
                padding: 0.5rem;
            }
        }

        .hamburger {
            display: flex;
        }
    }

    .section {
        padding: 60px 20px;
    }

    .section-title {
        font-size: 1.8rem;
    }

    .features-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .login-box,
    .download-box {
        padding: 30px 20px;
    }

    .download-btns {
        flex-direction: column;
    }
}

@media screen and (max-width: 480px) {
    .header {
        .logo {
            height: 40px;
        }
    }

    .section-title {
        font-size: 1.5rem;
    }

    .section-content {
        font-size: 1rem;
    }
}

/* 滚动平滑效果 */
html {
    scroll-behavior: smooth;
}
</style>
